import React from 'react';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration: LazyComponent<
	typeof import('@jira/jira-spa-apps-project-settings-service-desk-employee-onboarding-configuration/src/ui/EmployeeOnboardingConfigurationView.tsx').default
> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-employee-onboarding-configuration", jiraSpaEntry: "async-project-settings-service-desk-employee-onboarding-configuration" */ '@jira/jira-spa-apps-project-settings-service-desk-employee-onboarding-configuration/src/ui/EmployeeOnboardingConfigurationView.tsx'
		),
	),
);

const ServicedeskEmployeeOnboardingConfigurationComponent = (): JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskEmployeeOnboardingConfiguration}
		pageId="project-settings-employee-onboarding-configuration"
		shouldShowSpinner
	/>
);

export default ServicedeskEmployeeOnboardingConfigurationComponent;
